<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Prep Process Form Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <b-form @submit.prevent="submitForm">

      <b-row class="mt-4">
        <b-col>

          <b-form-group label="Name" :label-cols="2">
            <b-form-input
              id="name"
              v-model="form_data.name"
              :state="!$v.form_data.name.$invalid"
              type="text"
              placeholder="Process Name"
            />
            <b-form-invalid-feedback v-if="$v.form_data.name.$error">
              Required
            </b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Description" :label-cols="2">
            <b-form-input
              id="description"
              v-model="form_data.description"
              type="text"
              placeholder="Process Description"
            />
          </b-form-group>

        </b-col>
      </b-row>

      <!-- validation error -->
      <b-row v-if="invalid" class="mt-4">
        <b-col>
          <b-alert variant="danger" show>
            <i class="fa fa-exclamation-triangle" /> Please review the form and complete all required fields.
          </b-alert>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-button
            type="submit"
            class="my-4 float-right py-3 px-5"
            variant="success"
          >
            <i class="fal fa-save" /> Save
          </b-button>
        </b-col>
      </b-row>

    </b-form>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate/src'

export default {
  name: 'WorkflowPrepProcessForm',
  components: {
  },
  mixins: [validationMixin],
  props: {
    sample_type: {
      type: Object,
      default: () => null
    },
    prep_process: {
      type: Object,
      default: () => null
    }
  },
  data () {
    return {
      loading: true,

      form_data: {
        name: null,
        description: null
      },

      column_type_opts: [
        { text: 'Attribute', value: 'attribute' },
        { text: 'Analyte', value: 'analyte' }
      ]
    }
  },
  validations: {
    form_data: {
      name: { required }
    }
  },
  mounted () {
    this.loading = true

    this.init()
  },
  computed: {
    invalid() {
      return this.$v && this.$v.$dirty && this.$v.$invalid
    }
  },
  methods: {
    initFormData () {
      if (this.prep_process && this.prep_process.id) {
        this.form_data.name = this.prep_process.name
        this.form_data.description = this.prep_process.description
      }
    },

    init () {
      this.initFormData()
      this.loading = false
    },

    submitForm () {
      this.$v.$touch()
      if (this.invalid) return

      return this.$emit('submit', {
        name: this.form_data.name,
        description: this.form_data.description,
        sample_type_id: this.sample_type.id
      })
    }
  }
}
</script>
